import { openLegend as openLegendAction } from '@/redux/legend/legend.slice';
import { store } from '@/redux/store';

export const openLegend = (): void => {
  const { dispatch } = store;

  dispatch(openLegendAction());
};
